/*jshint browserify: true */
'use strict';

var PdfElement = require('./pdf-element.js');

/**
 * @name PdfTickBoxElement
 *
 * A tick-box element will render a tick (or cross) on-top of a PDF page.
 */
var PdfTickBoxElement = (function PdfTickBoxElementClosure() {
    function PdfTickBoxElement() {
        PdfElement.call(this);

        this.placeHolder = '';
        this.comparisonValue = '';
        this.tickStyle = 'tick';
    }

    PdfTickBoxElement.prototype = Object.create(PdfElement.prototype);
    PdfTickBoxElement.prototype.constructor = PdfTickBoxElement;

    function drawCross(context, x, y, width, height) {
        context.beginPath();
        context.moveTo(x + (width * 0.15), y + (height * 0.15));
        context.lineTo(x + width - (width * 0.15), y + height - (width * 0.15));
        context.stroke();

        context.beginPath();
        context.moveTo(x + width - (width * 0.15), y + (height * 0.15));
        context.lineTo(x + (width * 0.15), y + height - (height * 0.15));
        context.stroke();
    }

    var tickBoxScaledVertices = [
        { x: 0.15, y: 0.55 },
        { x: 0.4, y: 0.85 },
        { x: 0.85, y: 0.15 }];

    function drawTick(context, x, y, width, height) {
        context.beginPath();
        context.moveTo(x + (width * tickBoxScaledVertices[0].x), y + (height * tickBoxScaledVertices[0].y));
        for (var i = 1; i < tickBoxScaledVertices.length; i++) {
            context.lineTo(x + (width * tickBoxScaledVertices[i].x), y + (height * tickBoxScaledVertices[i].y));
        }
        context.stroke();
    }

    PdfTickBoxElement.prototype.renderToCanvas = function (pdfViewport, canvasContext, selected, mousePosition, interactionMode) {
        PdfElement.prototype.renderToCanvas.call(this, pdfViewport, canvasContext, selected, mousePosition, interactionMode);
        var translatedRectangle = coordinates.translatePdfRectangleToViewportRectangle(pdfViewport, this);

        canvasContext.save();
        canvasContext.strokeStyle = 'black';
        canvasContext.globalAlpha = 1;
        canvasContext.lineWidth = 2;

        if (this.tickStyle === 'tick') {
            drawTick(canvasContext, translatedRectangle.x, translatedRectangle.y, translatedRectangle.width, translatedRectangle.height);
        } else {
            drawCross(canvasContext, translatedRectangle.x, translatedRectangle.y, translatedRectangle.width, translatedRectangle.height);
        }

        canvasContext.restore();
    };

    return PdfTickBoxElement;
})();

module.exports = PdfTickBoxElement;

var coordinates = require('../Coordinates');